<style src="./styles.scss" lang="scss"></style>
<template>
  <div>
    <div class="header">
      <div class="right-content">
        <month-picker-input
          lang="pt"
          :default-month="todayMonth"
          :default-year="todayYear"
          input-pre-filled
          @change="selectDate"
        ></month-picker-input>
        <button
          class="btn btn-outline add-button"
          @click="addMovement"
          v-if="permissionCreate"
        >
          <i class="fa fa-plus"></i>
        </button>
        <p class="divider">|</p>

        <button
          class="btn btn-outline button-filter all"
          @click="changeFilter(filterTypes.ALL)"
        >
          Todos
        </button>
        <button
          class="btn btn-outline button-filter receive"
          @click="changeFilter(filterTypes.RECIEVE)"
        >
          Recebimentos
        </button>
        <button
          class="btn btn-outline button-filter expense"
          @click="changeFilter(filterTypes.EXPENSE)"
        >
          Despesas
        </button>
      </div>
      <div>
        <button
          class="btn btn-outline button-history"
          @click="navigateToFinancialAccountHistory"
        >
          <i class="fa fa-book icon"> </i>
          Histórico
        </button>
        <button
          class="btn btn-outline button-filter transfer"
          @click="changeFilter(filterTypes.TRANSFER)"
        >
          Trânsferencia
        </button>
      </div>
    </div>
    <br />
    <main>
      <table class="table table-hover table-mail">
        <thead class="table-head">
          <tr>
            <th>DATA</th>
            <th>PAGAMENTO</th>
            <th>DESCRIÇÃO</th>
            <th>VALOR</th>
            <th>PAGAMENTO</th>
            <th>LABELS</th>
            <template v-if="transferMode">
              <th>ORIGEM</th>
              <th>DESTINO</th>
            </template>
            <th>PAGO?</th>
            <th>Arquivo</th>
            <th>Credor</th>
            <th v-if="!transferMode && permissionUpdate"></th>
            <th v-if="permissionDelete"></th>
          </tr>
        </thead>

        <tbody class="table-list">
          <tr
            v-for="(movement, key) in filteredMovements"
            :key="key"
            :class="[movement.type, { removed: movement.isRemoved }]"
          >
            <td class="" :class="movement.type">
              {{ DateBR(movement.expiration) }}
              <span
                class="movement-indicator"
                :class="`${movement.employee.movementType}-indicator`"
                v-if="movement.employee.isEmployee"
              >
                |
                {{ movementIndicator(movement.employee.movementType) }}
              </span>
            </td>
            <td>
              {{ DateBR(movement.paymentDate ? movement.paymentDate : '') }}
            </td>
            <td>{{ movement.description }}</td>
            <td>{{ totalToCurrencyBR(movement.amount) }}</td>
            <td>{{ paymentType(movement.paymentType) }}</td>
            <td>
              <div v-for="(label, index) in movement.labels" :key="index">
                <LabelInfo :label="label" />
              </div>
            </td>
            <template v-if="transferMode">
              <td>
                {{ movement.account.name }}
              </td>
              <td>
                {{ movement.transferredTo.name }}
              </td>
            </template>

            <td>
              <input
                v-if="!movement.isRemoved && hasPaymentPermission(movement.type)"
                type="checkbox"
                :checked="movement.paid"
                class="form-check-input"
                @change="changeMovementPaid(!movement.paid, movement)"
              />
              <h4 v-else-if="!movement.isRemoved">
                {{ movement.paid ? 'Sim' : 'Não' }}
              </h4>
            </td>
            <td>
              <button
                v-if="movement.filesPath.length > 0"
                class="btn btn-outline"
                @click="showFiles(movement.filesPath)"
              >
                <i class="fa fa-file"></i>
              </button>
            </td>
            <td>
              <h4 v-if="movement.creditor">
                {{ getCreditorName(movement.creditor) }}
              </h4>
            </td>

            <td class="list-command" v-if="!transferMode && permissionUpdate">
              <button
                v-if="!movement.isRemoved"
                class="btn btn-outline"
                @click="editMovement(movement._id)"
              >
                <i class="fa fa-edit text-success"></i>
              </button>
            </td>
            <td class="list-command" v-if="permissionDelete">
              <button
                v-if="!movement.isRemoved && !isClose(movement)"
                class="btn btn-outline"
                @click="removeMovemnt(movement._id)"
              >
                <i class="fa fa-trash text-danger"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </main>
  </div>
</template>

<script>
import { MonthPickerInput } from 'vue-month-picker';
import { formatISO, format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { URI } from '@/config/config';

import LabelInfo from '../../../../components/labelInfo/LabelInfo';
import { toast } from '@/plugins/toast';

const filterTypes = {
  RECIEVE: 'receive',
  EXPENSE: 'expense',
  TRANSFER: 'transfer',
  ALL: 'all',
};
const EmployeeMovementType = {
  WITHDRAW: 'withdraw',
  REINFORCEMENT: 'reinforcement',
  CLOSE: 'close',
  DIFFERENCE: 'difference',
};
const PersonType = {
  PHYSICAL: 'physical',
  LEGAL: 'legal',
};

export default {
  components: {
    MonthPickerInput,
    LabelInfo,
  },
  data() {
    return {
      todayMonth: new Date().getMonth() + 1,
      todayYear: new Date().getFullYear(),
      range: {},
      movements: [],
      filteredMovements: [],
      filterTypes: filterTypes,
      selectedFilter: filterTypes.ALL,
    };
  },
  computed: {
    transferMode() {
      return this.selectedFilter === filterTypes.TRANSFER;
    },
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'account-movement-info',
        'READ',
      );
    },
    //
    permissionPayReceives() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'pay-receives',
        'UPDATE',
      );
    },
    permissionPayExpense() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'pay-expense',
        'UPDATE',
      );
    },
    permissionPayTransfer() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'pay-transfer',
        'UPDATE',
      );
    },
    //
    permissionCreate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'account-movement-info',
        'CREATE',
      );
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'account-movement-info',
        'UPDATE',
      );
    },
    permissionDelete() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'account-movement-info',
        'DELETE',
      );
    },
  },
  props: {
    selectedAccount: Object,
    accountRef: null,
  },

  watch: {
    selectedFilter() {
      this.filterList();
    },
    selectedAccount() {
      this.listMovements();
      this.$emit('update-range', this.range);
    },
    range() {
      this.listMovements();
    },
  },

  methods: {

    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },

    DateBR(dt) {
      if (!dt) return null;
      return format(new Date(dt), 'dd/MM', {
        locale: ptBR,
      });
    },
    selectDate(date) {
      const range = {
        from: formatISO(date.from),
        to: formatISO(date.to),
      };
      this.range = range;
      this.$emit('update-range', range);
    },
    paymentType(type) {
      switch (type) {
        case 'cash': {
          return 'Dinheiro';
        }
        case 'credit': {
          return 'Crédito';
        }
        default:
          return 'Débito';
      }
    },
    async listMovements() {
      try {
        if (!this.permissionRead) {
          return;
        }
        if (!this.selectedAccount._id) {
          return;
        }
        const movements = await this.$store.dispatch(
          'FINANCIAL-ACCOUNT/ListMovements',
          {
            range: this.range,
            financialAccountId: this.selectedAccount._id,
          },
        );
        this.movements = movements;
        this.filterList();
      } catch (error) {
        toast.error(
          'Falha ao listar movimentos do mês ' + this.todayMonth,
        );
      }
    },
    changeFilter(filter) {
      this.selectedFilter = filter;
    },
    filterList() {
      if (this.selectedFilter === filterTypes.ALL) {
        this.filteredMovements = this.movements.filter(
          (item) => item.type !== filterTypes.TRANSFER,
        );
        return;
      }
      this.filteredMovements = this.movements.filter(
        (item) => item.type === this.selectedFilter,
      );
    },
    editMovement(movementId) {
      this.$router.push({
        name: 'MovementInfoEdit',
        params: { movementId },
      });
    },
    addMovement() {
      this.$router.push({
        name: 'MovementInfo',
      });
    },
    async removeMovemnt(movementId) {
      try {
        if (confirm('Deseja excluir esse movimento?')) {
          await this.$store.dispatch(
            'FINANCIAL-ACCOUNT/RemoveMovement',
            movementId,
          );
          this.listMovements();
          this.$emit('refresh-account');
        }
      } catch (error) {
        toast.error('Falha ao remover movimento');
      }
    },
    async changeMovementPaid(paid, movement) {
      try {
        if (movement.isRemoved || !this.hasPaymentPermission(movement.type)) {
          return;
        }
        const payload = {
          paid,
        };
        await this.$store.dispatch('FINANCIAL-ACCOUNT/SetMovementPaid', {
          payload,
          movementId: movement._id,
        });
        this.$emit('refresh-account');
      } catch (error) {
        toast.error('Falha ao atualizar status');
      }
    },
    movementIndicator(employeeMovement) {
      switch (employeeMovement) {
        case EmployeeMovementType.WITHDRAW:
          return 'Retirada';
        case EmployeeMovementType.REINFORCEMENT:
          return 'Reforço';
        case EmployeeMovementType.CLOSE:
          return 'Fechamento';
        case EmployeeMovementType.DIFFERENCE:
          return 'Diferença';
        default:
          return '';
      }
    },
    hasPaymentPermission(type) {
      switch (type) {
        case filterTypes.RECIEVE:
          return this.permissionPayReceives;
        case filterTypes.EXPENSE:
          return this.permissionPayExpense;
        case filterTypes.TRANSFER:
          return this.permissionPayTransfer;
        default:
          return false;
      }
    },
    showFiles(files) {
      files.forEach((file) => {
        const path = `${URI}notify-photos/${file}`;
        window.open(path);
      });
    },
    getCreditorName(creditor) {
      if (creditor.personType === PersonType.PHYSICAL) {
        return creditor.physical.name;
      } else if (creditor.personType === PersonType.LEGAL) {
        return creditor.legal.companyName;
      } else {
        return '';
      }
    },
    isClose({ employee }) {
      return employee.movementType === EmployeeMovementType.CLOSE
        ? true
        : false;
    },
    navigateToFinancialAccountHistory() {
      this.$router.push({
        name: 'FinancialAccountHistoryTable',
      });
    },
  },
};
</script>
